import { useAuthContext } from './agencyAuthHook'
import { getPartiesStats } from '../redux/reducers/partiesBookingStatsSlice'
import { useDispatch } from 'react-redux';

export default function PartiesBookingStatsHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { agency } = useAuthContext()
    const getAllPartiesStats=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/agencies/parties/get-parties-booking-stats`,{
          headers:{
            'Authorization': `Bearer ${agency.token}`
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getPartiesStats(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getAllPartiesStats}
}
